import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Industrialization from './components/Industrialization';
import Sustainability from './components/Sustainability';
import Services from './components/Services';
import Projects from './components/Projects';
import Innovation from './components/Innovation';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Industrialization />
      <Sustainability />
      <Services />
      <Projects />
      <Innovation />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
